module.exports = __webpack_public_path__ + "assets/img/user-clock.8880a4a2.svg";